
import { Component, Vue } from "vue-property-decorator";
import IconSearchEmployee from "@/components/common/icon/IconSearchEmployee.vue";
import { Getter } from "vuex-class";
import { User } from "@/entities";
import IconQuestion from "@/components/common/icon/IconQuestion.vue";

@Component({
  name: "firms-header",
  components: {
    IconQuestion,
    IconSearchEmployee,
  },
})
export default class FirmsHeader extends Vue {
  @Getter("getLoggedUser") getLoggedUser!: User;

  get showUsersGuide(): boolean {
    return this.getLoggedUser?.country?.showUsersGuide || false;
  }

  async openUsersGuideModal(): Promise<void> {
    this.$bvModal.show("usersGuideModal");
  }
}
